import Url from 'url-parse';

type UrlObjType = {
  host: string;
  hostname: string;
  href: string;
  origin: string;
  pathname: string;
  port: string;
  protocol: string;
  query: ObjectType;
  slashes: boolean;
};

export const getUrlObject = (url: string): UrlObjType => {
  try {
    const urlObj = new Url(url, null, true);
    return urlObj ?? {};
  } catch (error) {
    return {} as UrlObjType;
  }
};
